import React, { type JSX } from 'react';
import useGame from '../../contexts/useGame';
import TalentTreePercentBadge from '../TalentTreePercentBadge/TalentTreePercentBadge';
import {
  type RetailWarcraftTalentTreeBuildNode,
  type RetailWarcraftTalentTreeEntry,
} from '../../typings/viewModels/retailWarcraftTalentTreeBuildNode';
import {
  heatMapPercentageClassName,
  heatMapPercentageForEntry,
} from '../TalentTreeNode/TalentTreeNode';
import { createTalentTreeUrl } from '../../helpers/talentTreeUrl';

export type ActiveTalentTreeNodeProps = {
  node: RetailWarcraftTalentTreeBuildNode;
  entry: RetailWarcraftTalentTreeEntry;
  spellModifierId: number;
};

export default function ActiveTalentTreeNode({
  node,
  entry,
  spellModifierId,
}: ActiveTalentTreeNodeProps): JSX.Element {
  const game = useGame();

  const { pointsInvested: invested } = node;
  const { spellId, definitionId, icon, name } = entry;

  const isActive = node.entry?.id === entry.id;

  const isHeatMap = !!node.heatMapPercent;

  const relativePct = heatMapPercentageForEntry(node, entry);
  const heatMapClassName = heatMapPercentageClassName(relativePct);

  return (
    <a
      className={`talent-tree-node talent-tree-node-active ${
        !isActive && !isHeatMap ? 'talent-tree-node--inactive' : ''
      } ${
        isHeatMap
          ? `talent-tree-node--${heatMapClassName} talent-tree-node-active--${heatMapClassName}`
          : ''
      }`}
      target='_blank'
      rel='noreferrer'
      href={createTalentTreeUrl(
        spellId,
        definitionId,
        invested,
        spellModifierId,
        game.abilityExternalSitePath,
      )}
      onClick={(e) => e.stopPropagation()}
    >
      <img
        src={`${game.assetServerBaseUrl}/img/warcraft/abilities/${icon}.jpg`}
        alt={name}
        loading='lazy'
      />
      {isHeatMap ? <TalentTreePercentBadge percent={relativePct} /> : null}
    </a>
  );
}
